import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';
import * as moment from 'moment';

// Service
import { LimitFlowProposalService } from '../../../service/limit-flow-proposal/limit-flow-proposal.service';
import { IMyDpOptions } from 'mydatepicker';

@Component({
	moduleId: module.id,
	selector: 'reference',
	templateUrl: 'reference.component.html'
})
export class ReferenceComponent implements OnInit {

	@Input('proposalID') proposalID: string = "";
	@Input('referenceObj') referenceObj: any[] = [];
	@Input('proposalStatus') proposalStatus: string = "";
	@Input('profileUser') profileUser: string = "";
	@Input('isUserOwner') isUserOwner: boolean = false;

	private token;
	public companyTypes: any[] = [];
	public editReferenceIndex: number;
	public mask = ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
	reference: FormGroup;

	private today = moment();
	
		//Option to datepicker
		private myDatePickerOptions: IMyDpOptions = {
			// other options...
			dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
			monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
			dateFormat: 'dd/mm/yyyy',
			showTodayBtn: false,
			//disableSince: {year: this.today.year(), month: this.today.month()+1, day: this.today.date()},
			//disableUntil: {year: this.today.getFullYear(), month: this.today.getMonth()+1, day: this.today.getDate()},
			//disableDateRanges: [{begin: {year: 2016, month: 11, day: 14}, end: {year: 2016, month: 11, day: 20}}],
			//editableDateField: false,
			height: "30px"
		};

	constructor(private flashMessagesService: FlashMessagesService, private limitFlowProposalService: LimitFlowProposalService, private fb: FormBuilder) {
		this.reference = fb.group({
			ID: '',
			TipoReferencia: ['Comercial', Validators.compose([Validators.required])],  // Comercial, Bancária
			TipoEmpresaID: ['', Validators.compose([Validators.required])],
			NomeEmpresa: '',
			NomeBanco: '',
			Municipio: ['', Validators.compose([Validators.required])],
			Telefone: ['', Validators.compose([Validators.required])],
			NomeContato: ['', Validators.compose([Validators.required])],
			Desde: '',
			LCAtual: '',
			Vigencia: '',
			Garantias: '',
			Comentarios: ''
		});
	}

	ngOnInit() {
		this.token = localStorage.getItem('yara.token');
		this.getCompany();
	}

	getCompany() {
		this.limitFlowProposalService.getCompany(this.token).subscribe(result => {
			if (result.Success) {
				this.companyTypes = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		})
	}

	changeRef(tipo) {
		var TipoEmpresaID = "";

		for (var key in this.companyTypes) {
			var obj = this.companyTypes[key];
			if (obj.Tipo === "Banco") {
				TipoEmpresaID = obj.ID;
			}
		}

		if (tipo === "Bancária") {
			this.reference.patchValue({
				TipoEmpresaID: TipoEmpresaID
			});
		}
	}

	saveProposalReference(reference: any) {
		for (var key in this.companyTypes) {
			var obj = this.companyTypes[key];
			if (obj.ID === reference.TipoEmpresaID) {
				reference.TipoEmpresa = obj;
			}
		}

		//Converte a data para o formato correto antes de inserir novo.

		reference.Desde = reference.Desde?reference.Desde.date.year+"-"+reference.Desde.date.month+"-"+reference.Desde.date.day: null
		reference.Vigencia = reference.Vigencia?reference.Vigencia.date.year+"-"+reference.Vigencia.date.month+"-"+reference.Vigencia.date.day: null


		this.limitFlowProposalService.referencesObj.push(reference);
		this.reference.reset();
		this.reference.patchValue({
			TipoReferencia: 'Comercial'
		});
		this.flashMessagesService.show("Referência adicionada", { cssClass: 'alert-success', timeout: 6000 });
	}

	deleteProposalReference(index) {
		this.limitFlowProposalService.referencesObj.splice(index, 1);
		this.flashMessagesService.show("Referência removida", { cssClass: 'alert-success', timeout: 6000 });
	}

	editReference(index) {
		this.editReferenceIndex = index;

		($(".references-list table tbody tr") as any).eq(index).addClass("edit-line");
		($(".reference-form") as any).addClass("editing");

		if (this.limitFlowProposalService.referencesObj[index].TipoReferencia === 'Comercial') {


			//define variaveis temporarias e transforma para um formato aceito pelo Datepicker.
			// Inserindo o valor no objeto.
			let tempDesde;
			let tempVigencia;

			if (this.limitFlowProposalService.referencesObj[index].Desde){
				tempDesde = moment(this.limitFlowProposalService.referencesObj[index].Desde);
			}
			if (this.limitFlowProposalService.referencesObj[index].Vigencia){
				tempVigencia = moment(this.limitFlowProposalService.referencesObj[index].Vigencia);
			}

			this.reference.patchValue({
				TipoReferencia: this.limitFlowProposalService.referencesObj[index].TipoReferencia,
				TipoEmpresaID: this.limitFlowProposalService.referencesObj[index].TipoEmpresaID,
				NomeEmpresa: this.limitFlowProposalService.referencesObj[index].NomeEmpresa,
				Municipio: this.limitFlowProposalService.referencesObj[index].Municipio,
				Telefone: this.limitFlowProposalService.referencesObj[index].Telefone,
				NomeContato: this.limitFlowProposalService.referencesObj[index].NomeContato,
				Desde: tempDesde?{date:{year: tempDesde.year(), month: tempDesde.month()+1, day: tempDesde.date()}}:null,
				LCAtual: this.limitFlowProposalService.referencesObj[index].LCAtual,
				Vigencia: tempVigencia?{date:{year: tempVigencia.year(), month: tempVigencia.month()+1, day: tempVigencia.date()}}:null,
				Garantias: this.limitFlowProposalService.referencesObj[index].Garantias,
				Comentarios: this.limitFlowProposalService.referencesObj[index].Comentarios
			});
		} else {

			//define variaveis temporarias e transforma para um formato aceito pelo Datepicker.
			// Inserindo o valor no objeto.

			let tempDesde;
			let tempVigencia;

			if (this.limitFlowProposalService.referencesObj[index].Desde){
				tempDesde = moment(this.limitFlowProposalService.referencesObj[index].Desde);
			}

			if (this.limitFlowProposalService.referencesObj[index].Vigencia){
				tempVigencia = moment(this.limitFlowProposalService.referencesObj[index].Vigencia);
			}

			this.reference.patchValue({
				TipoReferencia: this.limitFlowProposalService.referencesObj[index].TipoReferencia,
				TipoEmpresaID: this.limitFlowProposalService.referencesObj[index].TipoEmpresaID,
				NomeBanco: this.limitFlowProposalService.referencesObj[index].NomeBanco,
				Municipio: this.limitFlowProposalService.referencesObj[index].Municipio,
				Telefone: this.limitFlowProposalService.referencesObj[index].Telefone,
				NomeContato: this.limitFlowProposalService.referencesObj[index].NomeContato,
				Desde: tempDesde?{date:{year: tempDesde.year(), month: tempDesde.month()+1, day: tempDesde.date()}}:null,
				LCAtual: this.limitFlowProposalService.referencesObj[index].LCAtual,
				Vigencia: tempVigencia?{date:{year: tempVigencia.year(), month: tempVigencia.month()+1, day: tempVigencia.date()}}:null,
				Garantias: this.limitFlowProposalService.referencesObj[index].Garantias,
				Comentarios: this.limitFlowProposalService.referencesObj[index].Comentarios
			});
		}
	}

	saveReferenceEdit() {

		//define variaveis temporarias para a data e depois confere se existe para enviar no formato necessário.
		
		const tempDesde = this.reference.controls['Desde'].value;
		const tempVigencia = this.reference.controls['Vigencia'].value;

		

		if (this.limitFlowProposalService.referencesObj[this.editReferenceIndex]) {
			this.limitFlowProposalService.referencesObj[this.editReferenceIndex].TipoReferencia = this.reference.controls['TipoReferencia'].value;
			this.limitFlowProposalService.referencesObj[this.editReferenceIndex].TipoEmpresaID = this.reference.controls['TipoEmpresaID'].value;
			this.limitFlowProposalService.referencesObj[this.editReferenceIndex].NomeEmpresa = this.reference.controls['NomeEmpresa'].value;
			this.limitFlowProposalService.referencesObj[this.editReferenceIndex].NomeBanco = this.reference.controls['NomeBanco'].value;
			this.limitFlowProposalService.referencesObj[this.editReferenceIndex].Municipio = this.reference.controls['Municipio'].value;
			this.limitFlowProposalService.referencesObj[this.editReferenceIndex].Telefone = this.reference.controls['Telefone'].value;
			this.limitFlowProposalService.referencesObj[this.editReferenceIndex].NomeContato = this.reference.controls['NomeContato'].value;
			this.limitFlowProposalService.referencesObj[this.editReferenceIndex].Desde = tempDesde?tempDesde.date.year+"-"+tempDesde.date.month+"-"+tempDesde.date.day: null;
			this.limitFlowProposalService.referencesObj[this.editReferenceIndex].LCAtual = this.reference.controls['LCAtual'].value;
			this.limitFlowProposalService.referencesObj[this.editReferenceIndex].Vigencia = tempVigencia?tempVigencia.date.year+"-"+tempVigencia.date.month+"-"+tempVigencia.date.day: null;
			this.limitFlowProposalService.referencesObj[this.editReferenceIndex].Garantias = this.reference.controls['Garantias'].value;
			this.limitFlowProposalService.referencesObj[this.editReferenceIndex].Comentarios = this.reference.controls['Comentarios'].value;

			for (var key in this.companyTypes) {
				var obj = this.companyTypes[key];
				if (obj.ID === this.limitFlowProposalService.referencesObj[this.editReferenceIndex].TipoEmpresaID) {
					this.limitFlowProposalService.referencesObj[this.editReferenceIndex].TipoEmpresa = obj;
				}
			}

			this.editReferenceIndex = undefined;
			this.reference.reset();
			this.reference.patchValue({
				TipoReferencia: 'Comercial'
			});
			($(".references-list table tbody tr") as any).removeClass("edit-line");
			($(".reference-form") as any).removeClass("editing");
		}
	}

	cancelReferenceEdit() {
		this.editReferenceIndex = undefined;
		this.reference.reset();
		this.reference.patchValue({
			TipoReferencia: 'Comercial'
		});
		($(".references-list table tbody tr") as any).removeClass("edit-line");
		($(".reference-form") as any).removeClass("editing");
	}
}



// WEBPACK FOOTER //
// ./src/app/limit-flow-proposal/component/limit-flow-proposal/reference/reference.component.ts